import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { useThemeMode } from '@context/shared/ThemeContext';
import { TabBarStateProvider } from '@context/client/TabBarState';
import { TopNavHeightProvider } from '@context/client/TopNavHeight';
import { BottomBarProvider } from '@context/client/BottomBar';
import { MainLayout } from './main-layout/main-layout';

const ClientLayout = () => {
  const { setClientTheme } = useThemeMode();

  useEffect(() => {
    setClientTheme();
  }, [setClientTheme]);

  return (
    <TabBarStateProvider>
      <TopNavHeightProvider>
        <BottomBarProvider>
          <MainLayout>
            <Outlet />
          </MainLayout>
        </BottomBarProvider>
      </TopNavHeightProvider>
    </TabBarStateProvider>
  );
};

export default ClientLayout;
